import { useFormContext } from 'react-hook-form';

import type { ReviewResultFormContextData } from '../../types';

export const useReviewResultFormContext = useFormContext<ReviewResultFormContextData>;
